import { DocumentsListRequest } from "@gtpl/shared-models/logistics";
import appSettings from "apps/services/config";
import { DocumentsList } from "../documents-list.entity";

export class DocumentsListAdapter{

    public convertDtoToEntity(dto:any):DocumentsList[]{
        const conItems: DocumentsList[]  = []; 
        console.log('%%%%%%%%%%%%')
        console.log(dto)
        for(const doc of dto.file){
            const entity = new DocumentsList();
            entity.documentsListId = 0;
            entity.saleOrderId = dto.saleOrderId;
            entity.documentCategory = dto.documentCategory;
            entity.fileName = doc.name;
            entity.filePath = '/upload-files/post-sailing-upload-files/'+doc.name;
            entity.isUploaded = false;
            entity.isActive = true;
            entity.documentType = dto.documentType;
            entity.createdAt = new Date();
            entity.createdUser = "";
            entity.updatedAt = new Date();
            entity.updatedUser = "";
            entity.versionFlag = 1;
            conItems.push(entity)
        }
        return conItems;
    }
}